module.exports = __webpack_public_path__ + "media/images/undraw/psc/notify-c191d32d2cfd143897bbd2a11b5a1114.png";